import { render, staticRenderFns } from "./TInfo.vue?vue&type=template&id=3eedb924&"
import script from "./TInfo.vue?vue&type=script&lang=js&"
export * from "./TInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports